module.exports = __webpack_public_path__ + "static/img/intro-bg.611b126a.png";